export const simpleLogo = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 316.9 112"
  >
    <g id="Layer_1">
      <g>
        <g>
          <g>
            <path
              style={{ fill: '#F9F5E5' }}
              d="M138,1.4l-6.2-0.1c0,0-0.1,0-0.1,0l-3,0.2c0,0,0,0-0.1,0l-2.4,0c-0.5,0-0.8,0.4-0.9,0.8L125.2,5
            c0,0.5,0.4,0.9,0.8,0.9l2.3,0c0,0,0,0,0.1,0l1.7-0.1c0.5,0,0.9,0.4,0.9,0.9l-0.1,2.1c0,0,0,0.1,0,0.1l0.3,3.1c0,0,0,0.1,0,0.1
            l-0.2,3.1c0,0,0,0.1,0,0.1l0.2,3.1c0,0,0,0.1,0,0.1l-0.2,2.6c0,0.5,0.4,0.9,0.9,0.9l2.8-0.1c0.4,0,0.8-0.4,0.8-0.8l0.1-2.6
            c0,0,0-0.1,0-0.1l-0.2-3.1c0,0,0-0.1,0-0.1l0.2-3.2c0,0,0,0,0-0.1l-0.1-3.2l0-2.1c0-0.5,0.4-0.9,0.9-0.8l1.8,0.1
            c0,0,0.1,0,0.1,0l2.3-0.1c0.5,0,0.8-0.4,0.8-0.9l-0.1-2.7c0-0.4-0.4-0.8-0.8-0.8L138,1.4z"
            />
          </g>
          <g>
            <path
              style={{ fill: '#F9F5E5' }}
              d="M161.5,5l-0.1-2.4c0-0.6-0.5-1.1-1.1-1.1l-2.1-0.1c-0.7,0-1.2,0.5-1.2,1.2l0.1,2.9c0,0,0,0,0,0.1l0,2.6
            c0,0.6-0.5,1.1-1.1,1.1l-1.5,0.1c0,0-0.1,0-0.1,0l-4.2-0.1c-0.6,0-1.1-0.5-1.1-1.2l0.1-5.5c0-0.6-0.5-1.2-1.1-1.2l-2.2,0
            c-0.7,0-1.2,0.6-1.1,1.2l0.2,2.4c0,0,0,0.1,0,0.1l0,3.3l-0.1,3.4l0,3.3l-0.2,3.3c0,0.1,0,0.1,0,0.2l0.2,2.3c0,0.6,0.5,1,1.1,1
            l2.2,0.1c0.6,0,1.1-0.5,1.2-1.1l0.1-1.9c0-0.1,0-0.1,0-0.2l-0.3-2.6c0-0.1,0-0.1,0-0.2l0.1-1.3c0-0.6,0.6-1.1,1.2-1.1l1.3,0
            c0.1,0,0.1,0,0.2,0l2.6-0.3c0.1,0,0.2,0,0.2,0l1.4,0.1c0.5,0.1,1,0.5,1,1l0.2,1.5c0,0.1,0,0.2,0,0.2l-0.2,2.6c0,0,0,0.1,0,0.1
            l0,2c0,0.6,0.5,1.2,1.1,1.2l2.3,0c0.6,0,1.2-0.5,1.2-1.2l-0.3-9.2L161.5,5z"
            />
          </g>
          <g>
            <path
              style={{ fill: '#F9F5E5' }}
              d="M181.1,18.3c0-0.4-0.3-0.7-0.7-0.7l-3,0l-3.5,0.1l-2.6,0.1c-0.4,0-0.8-0.3-0.8-0.7l-0.1-1.5
            c0,0,0-0.1,0-0.1l0.1-1.5c0-0.4,0.3-0.7,0.7-0.7l2-0.1c0,0,0.1,0,0.1,0l2.4,0.2c0.4,0,0.8-0.3,0.8-0.7l0-3
            c0-0.4-0.3-0.8-0.7-0.8l-2.5,0c0,0,0,0-0.1,0l-1.9,0.1c-0.4,0-0.8-0.3-0.8-0.7l0-1.5c0-0.4,0.4-0.8,0.8-0.8l2.4,0.2
            c0,0,0,0,0.1,0l3.3,0l2.8-0.1c0.4,0,0.7-0.4,0.7-0.8l-0.1-2.8c0-0.4-0.3-0.7-0.7-0.7l-2.9-0.1c0,0-0.1,0-0.1,0l-3.4,0.2
            c0,0,0,0-0.1,0l-3.4,0L167,1.4c-0.4,0-0.8,0.3-0.8,0.8l0.2,2.7c0,0,0,0,0,0l0,3.3l-0.1,3.4l-0.1,3.3c0,0,0,0,0,0l0.1,3.3l0,2.8
            c0,0.4,0.3,0.8,0.8,0.8l2.3,0l2.8-0.1c0,0,0,0,0,0l5.7,0.1l2.4,0.1c0.4,0,0.8-0.3,0.8-0.8L181.1,18.3z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M36.2,86.3c-3.6-3.8-4-3.5-7.6-7.3c-0.8-0.8-1.9-1.6-3-1.2c-1.1,0.3-1,0.6-2.1,0.9c-1.6,0.5-2.5,2.2-2,3.9
              c1.2,2.6,1.1,2.6,2.4,5.1c1,2,0.2,4.5-1.9,5.2c-0.7,0.2-0.7,0.2-1.4,0.4c-1.6,0.5-3.3-0.6-3.8-2.2c-4.4-14.1-4.7-14-9.1-28.1
              c-0.5-1.6,0.6-3.3,2.2-3.8c6.4-2,6.4-2.2,12.8-4.2c1.6-0.5,3.2-0.5,4.7-0.5c1.6,0,2.9,0.4,4.2,1c1.4,0.6,2.6,1.2,3.7,2.3
              c1,1.2,1.8,2.6,2.3,4.5c0.8,2.6,1.1,4.8,0.6,6.8c-0.4,1.2-1.2,2.3-2,3.3c-1,1.2-0.7,2.8,0.4,3.9c2.6,2.7,2.6,2.7,5.2,5.5
              c1.5,1.6,0.8,4.8-1.4,5.5c-0.7,0.2-0.9-0.4-1.6-0.2C37.9,87.3,37,87.2,36.2,86.3z M31.1,64.5c-0.5-1.5-1.5-2.2-2.6-2.6
              c-1.1-0.4-2.4-0.8-3.9-0.4c-3,0.9-2.9,1.2-5.9,2.1c-1.6,0.5-2.5,2.2-2,3.8c0.5,1.4,0.3,1.5,0.8,2.9c0.5,1.6,2.3,2.2,3.9,1.7
              c3-0.9,3-0.9,6-1.9C30.6,69.2,32.1,67.4,31.1,64.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M78.1,61c0.5,2.7,0.3,5.2,0,7.6c-0.3,2.3-0.6,4.6-1.6,6.4c-1,1.8-2.8,3-4.5,4.2c-1.7,1.2-3.7,2-6.1,2.4
              c-2.4,0.4-4.6,0.7-6.6,0.2c-2-0.5-3.8-1.6-5.4-2.9c-1.6-1.3-3.2-2.8-4.3-4.9c-1.1-2.1-1.7-4.6-2.2-7.2
              c-0.5-2.7-0.2-5.2,0.1-7.5c0.3-2.3,0.3-4.6,1.3-6.5c1-1.8,2.5-3.5,4.2-4.7c1.7-1.2,4-1.8,6.4-2.3c2.4-0.4,4.7-0.6,6.8-0.1
              c2,0.5,3.8,1.7,5.4,3c1.6,1.3,2.7,3.2,3.8,5.3C76.4,56.1,77.6,58.3,78.1,61z M70.4,62.4c-0.3-1.6-0.4-3.1-1-4.4
              c-0.5-1.3-1.5-2.2-2.3-3c-0.8-0.9-1.5-2-2.6-2.4c-1.1-0.4-2.5-0.5-3.9-0.2c-1.4,0.3-2.5,1.1-3.4,1.8c-0.9,0.8-1.7,1.6-2.2,2.7
              c-0.5,1.1-0.4,2.4-0.4,3.9c-0.1,1.4-0.1,2.9,0.2,4.4c0.3,1.6,0.3,3.1,0.9,4.4c0.5,1.3,1.8,2,2.6,2.9c0.8,0.9,1.7,1.4,2.8,1.8
              c1.1,0.4,2.3,0.7,3.7,0.5c1.4-0.3,2.4-0.9,3.3-1.7c0.9-0.8,1.7-1.5,2.2-2.6c0.5-1.1,1-2.4,1-3.8C71.3,65.5,70.7,64,70.4,62.4z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M110.3,74.4c-1.3-2.7-0.8-2.9-2.1-5.6c-0.3-0.7-1.3-1.3-2-1.2c-5,0.3-5,0.7-10,1c-1.2,0.1-2.3,0.8-2.5,1.9
              c-0.5,2.8-0.3,2.8-0.8,5.6c-0.2,0.7-0.9,1.3-1.7,1.3c-1.9,0.2-1.9,0.4-3.9,0.6c-1.2,0.1-2-1.2-1.6-2.4
              c4.6-16.6,4.1-16.7,8.6-33.3c0.2-0.7,1-1.3,1.7-1.4c2.3-0.2,2.3-0.1,4.5-0.3c0.7-0.1,1.3,0.4,1.6,1.1
              c7.7,15.4,7.9,15.3,15.6,30.7c0.5,1.1-0.3,2.8-1.5,2.9c-2,0.2-2,0.3-4.1,0.5C111.5,75.8,110.6,75.1,110.3,74.4z M101.2,55.2
              c-0.2-0.4-0.1-1.5-0.5-2.4c-0.4-0.9-2.4-0.8-2.6,0.2c-0.2,1,0,2-0.1,2.4c-0.5,2.1-0.7,2.1-1.3,4.2c-0.3,1.2,0.7,2.1,1.9,2
              c1.6-0.2,1.6-0.1,3.2-0.2c1.2-0.1,1.7-1.2,1.2-2.3C102,57.3,102.2,57.2,101.2,55.2z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M154,55.9c0.1,3.1-0.3,5.8-1.3,8c-1,2.3-2,4.4-3.7,5.9c-1.7,1.5-3.7,2.6-5.9,3.3c-2.2,0.7-4.5,0.8-6.7,0.9
              c-3.8,0.1-3.8,0.6-7.6,0.7c-1.7,0-3.3-1.6-3.3-3.3c-0.4-14.8-0.3-14.8-0.6-29.5c0-1.7,1.4-2.9,3-2.9c4.1-0.1,4-0.6,8.1-0.7
              c2.5-0.1,4.9,0.7,7,1.3c2.2,0.6,3.9,1.6,5.5,3c1.6,1.4,2.9,3,3.9,5.3C153.4,50,153.9,52.6,154,55.9z M147,56.1
              c-0.1-3.6-1.1-6.4-2.8-8.1c-1.7-1.8-4.5-2.3-8.3-2.2c-0.4,0-0.4,0-0.7,0c-1.7,0-3.2,1.3-3.1,2.9c0.2,7.8,0.7,7.8,0.9,15.6
              c0,1.7,1.1,2.8,2.8,2.8c0.2,0,0.2,0.1,0.5,0.1c1.9,0,3.5-0.1,4.9-0.7c1.4-0.6,2.1-1.7,3-2.7c0.9-1,1.9-1.8,2.3-3.2
              C146.9,59.2,147.1,57.7,147,56.1z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M185.8,48.3c-1.2,0.5-2.5,0.2-3.3-0.8c-0.4-0.4-0.9-0.7-1.3-1c-1-0.7-2.3-0.9-3.9-1
              c-1.3-0.1-2.5,0.1-3.5,0.6c-1.1,0.5-2.2,1-2.9,2c-0.8,1-0.9,2.3-1.4,3.7c-0.4,1.4-1.1,2.8-1.2,4.4c-0.1,1.6,0.3,3.1,0.6,4.5
              c0.3,1.4,0.9,2.6,1.6,3.6c0.7,1,1.4,2.1,2.4,2.7c1,0.6,2.3,1.1,3.6,1.2c1.6,0.1,3.1-0.4,4.2-1.1c0.5-0.3,0.8-1.1,1.3-1.7
              c1-1.1,2.7-1.1,3.9-0.3c0.5,0.3,0.7,0,1.2,0.3c1.5,1,1.7,3.3,0.6,4.7c-1,1.2-2.2,2.1-3.4,2.9c-2.2,1.3-4.9,2.2-8.2,2.1
              c-2.3-0.1-4.3-1.1-6.2-2c-1.9-0.9-3.7-1.9-5-3.6c-1.3-1.6-1.9-3.8-2.5-6.1c-0.7-2.3-1.6-4.7-1.5-7.6c0.1-2.7,1-5.1,1.9-7.3
              c0.9-2.2,1.6-4.4,3.1-6c1.5-1.6,3.4-2.5,5.4-3.3c2-0.8,4.1-1.3,6.5-1.2c1.7,0.1,3.1,0.6,4.4,1.1c1.3,0.4,2.7,0.7,3.7,1.4
              c1,0.7,1.8,1.7,2.6,2.7c0.2,0.2,0.2,0.2,0.3,0.4c1,1.3,0.6,3.6-0.9,4.2C186.8,48.3,186.7,47.9,185.8,48.3z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M220.7,78.9c-1.2,0-2.1-1.1-2.2-2.3c-0.3-2.8-0.5-2.8-0.8-5.6c-0.2-0.7-0.7-1.2-1.4-1.3
              c-5.3-0.6-5.3-0.3-10.6-0.9c-0.7-0.1-1.3,0-1.6,0.7c-1.3,2.7-1.4,2.6-2.7,5.3c-0.3,0.7-1,1.2-1.7,1.1c-1.9-0.2-1.9-0.3-3.9-0.5
              c-1.2-0.1-1.9-1.4-1.4-2.5c7.9-15.3,8.2-15.2,16.1-30.5c0.3-0.6,0.7-0.9,1.4-0.8c2.3,0.2,2.3-0.3,4.6,0
              c0.7,0.1,1.4,0.8,1.6,1.5c4.3,16.7,4,16.7,8.3,33.4c0.3,1.2-0.5,1.9-1.7,1.8C222.7,78.3,222.7,78.8,220.7,78.9z M213.3,52.5
              c-0.1-0.6-0.9-0.8-1.1-0.2c-1.7,3.7-1.5,3.8-3.2,7.5c-0.5,1.1,0.1,2.3,1.3,2.4c1.6,0.2,1.7-0.1,3.3,0.1c1.2,0.1,2-0.6,1.8-1.8
              C214.1,56.5,214.2,56.4,213.3,52.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M260.5,74.3c-0.3,1.7-0.7,3.2-1.5,4.5c-0.8,1.3-2.1,2-3.4,2.7c-1.3,0.8-2.8,1.2-4.6,1.4
              c-1.8,0.2-3.9,0.1-6.3-0.3c-2.9-0.6-5.6-1.4-7.8-3c-1.1-0.8-2.3-1.7-3.1-2.7c-1.1-1.4-0.4-3.5,1.2-4.4c0.5-0.3,0.2-0.6,0.7-0.9
              c1.3-0.7,2.7-0.2,3.7,0.9c0.6,0.7,1.5,1.2,2.3,1.7c1.4,0.9,2.9,1.6,4.6,1.9c2.1,0.4,3.7,0.5,4.8,0.1c1.1-0.4,1.4-1.4,1.7-2.8
              c0.1-0.6,0.5-1,0.4-1.5c-0.1-0.5-0.4-1-0.8-1.5c-0.5-0.5-1.5-0.6-2.4-1.1c-1-0.5-2.1-1.4-3.6-2.1c-1.5-0.7-3-1.3-4.2-2
              c-1.2-0.8-2.2-1.7-3.1-2.7c-0.8-1-1.4-2.1-1.7-3.3c-0.3-1.3-0.4-2.8,0-4.5c0.3-1.6,0.8-3.1,1.7-4.2c0.9-1.1,2.2-1.9,3.5-2.5
              c1.3-0.7,2.8-0.8,4.4-1c1.6-0.2,3.2-0.4,5,0c2.7,0.5,4.9,1.7,6.7,3.1c1,0.7,1.9,1.4,2.7,2.3c1.3,1.4,0.8,3.2-0.7,4.2
              c-0.5,0.3-0.4,0.3-0.9,0.6c-1.2,0.8-2.6,0.8-3.6-0.3c-0.5-0.5-1.2-0.8-1.7-1.2c-1.2-0.9-2.5-1.2-4.1-1.6
              c-0.9-0.2-1.7-0.5-2.3-0.5c-0.7,0.1-1.2,0.3-1.6,0.5c-0.5,0.2-1.1,0.2-1.4,0.5c-0.2,0.3,0.2,1,0.1,1.4
              c-0.1,0.6-0.1,0.9,0.1,1.3c0.1,0.4,0,1.1,0.5,1.5c0.5,0.4,1.2,0.8,2,1.3c0.8,0.4,1.9,1,3.3,1.6c1.3,0.6,2.7,1.2,4,1.9
              c1.3,0.7,2.5,1.4,3.5,2.5c1,1,1.7,2.2,2.2,3.6C261,70.7,260.9,72.4,260.5,74.3z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M286.9,66.5c-2.9,11-3.2,11-6.1,22c-0.4,1.5-1.9,2.1-3.4,1.6c-1.3-0.4-1.4-0.1-2.6-0.5
              c-1.4-0.4-2.2-1.9-1.7-3.4c3.4-10.9,3-11.1,6.4-22c0.5-1.6,0-3.3-1.6-3.8c-2-0.6-1.9-0.7-3.9-1.4c-1.6-0.5-2.6-1.9-2.1-3.5
              c0.1-0.4,0.2-0.4,0.4-0.8c0.5-1.6,2.1-2.3,3.7-1.8c10.2,3.2,10.4,2.8,20.6,5.9c1.6,0.5,2.3,2.3,1.8,3.9
              c-0.1,0.4,0.1,0.5-0.1,0.9c-0.5,1.6-2.4,2.7-4,2.2c-2-0.6-1.8-1.1-3.8-1.7C288.8,63.7,287.4,64.9,286.9,66.5z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M87.5,99.9L87,99.4c-0.1-0.1-0.2-0.1-0.3-0.2l-1-0.4c-0.1-0.1-0.3-0.1-0.4,0l-0.9,0.2
              c-0.2,0-0.3,0.1-0.4,0.2l-0.7,0.7c-0.1,0.1-0.1,0.2-0.2,0.2l-0.5,1.1c0,0.1-0.1,0.2-0.1,0.3l-0.1,1.5c0,0,0,0.1,0,0.1l0.1,1.4
              c0,0.1,0,0.2,0.1,0.3l0.6,1c0,0.1,0.1,0.1,0.1,0.1l0.7,0.7c0.1,0.1,0.3,0.2,0.4,0.2l0.9,0.2c0.1,0,0.2,0,0.4,0l1.1-0.3
              c0.2,0,0.3-0.1,0.4-0.2l0.5-0.6c0.2-0.3,0.7-0.4,1-0.2l1,0.6c0.4,0.2,0.5,0.7,0.3,1l-0.2,0.4c0,0.1-0.1,0.2-0.2,0.2l-0.9,0.8
              c-0.1,0.1-0.2,0.1-0.3,0.1l-1.2,0.4c-0.1,0-0.1,0-0.2,0l-1.4,0.1c-0.1,0-0.1,0-0.2,0l-2.1-0.3c-0.1,0-0.2-0.1-0.3-0.1l-1.6-1.1
              c-0.1-0.1-0.2-0.2-0.2-0.3l-1-1.9c0-0.1-0.1-0.1-0.1-0.2l-0.3-1.2c0,0,0-0.1,0-0.1l-0.1-1.3c0-0.1,0-0.1,0-0.2l0.4-2.5
              c0-0.1,0-0.2,0.1-0.2l1-1.9c0.1-0.1,0.1-0.2,0.2-0.3l1.6-1.2c0.1-0.1,0.2-0.1,0.4-0.1l2.1-0.3c0.1,0,0.1,0,0.2,0l1.5,0.1
              c0.1,0,0.1,0,0.2,0l1.1,0.4c0.1,0,0.2,0.1,0.3,0.2l0.8,0.8c0,0,0,0,0.1,0.1l0.3,0.4c0.3,0.4,0.1,1-0.3,1.2l-1.1,0.5
              C88.1,100.2,87.7,100.1,87.5,99.9z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M100.3,109l-0.6-1c0,0-0.1-0.1-0.1-0.2l-0.6-1.5c0,0,0-0.1-0.1-0.1l-0.5-1c-0.2-0.3-0.5-0.5-0.8-0.5
              l-1.2,0c-0.5,0-0.9,0.4-0.9,0.9l0,0.6c0,0,0,0.1,0,0.1l0.1,1.5l0,0.7c0,0.5-0.4,1-0.9,1l-0.8,0c-0.5,0-0.9-0.4-0.9-0.9l0-1
              c0,0,0-0.1,0-0.1l0.2-1.7c0-0.1,0-0.1,0-0.2l-0.1-1.8l-0.1-1.9l0-1.9l0-1.9l0-1c0-0.5,0.4-0.9,0.9-0.9l1.1,0c0,0,0.1,0,0.1,0
              l1.9,0.1c0,0,0.1,0,0.1,0l1.9-0.1c0,0,0.1,0,0.1,0l1.5,0.2c0.2,0,0.3,0.1,0.4,0.2l1,0.7c0.1,0,0.1,0.1,0.2,0.2l0.8,1
              c0.1,0.1,0.1,0.2,0.2,0.3l0.4,1.4c0,0.2,0.1,0.3,0,0.5l-0.5,1.9c-0.1,0.2-0.2,0.4-0.4,0.5l-1.1,0.7c-0.4,0.3-0.5,0.7-0.3,1.2
              l0.4,1c0,0,0,0,0,0.1l0.9,1.6l0.2,0.4c0.3,0.6-0.1,1.3-0.8,1.4l0,0c0,0-0.1,0-0.1,0l-0.9-0.1
              C100.7,109.4,100.4,109.3,100.3,109z M100.6,100.2l-0.2-0.5c-0.1-0.2-0.3-0.4-0.5-0.4l-0.8-0.3c-0.1-0.1-0.3-0.1-0.4-0.1
              l-1.5,0.1l-0.8,0c-0.5,0-0.9,0.4-0.9,0.9l0,0.8c0,0,0,0.1,0,0.1l0,0.7c0,0.5,0.5,0.9,1,0.9l0.8,0l1.6,0c0.1,0,0.2,0,0.3,0
              l0.8-0.2c0.2-0.1,0.4-0.2,0.6-0.5l0.2-0.5C100.8,100.7,100.8,100.4,100.6,100.2z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M107.2,109.4c-0.5,0-1-0.4-1-0.9l-0.1-0.9l0-1.8c0,0,0,0,0-0.1l0.1-1.8l0.1-1.9l0-1.8c0,0,0,0,0-0.1
              l0.1-1.8c0,0,0-0.1,0-0.1l-0.1-0.8c0-0.6,0.4-1.1,1-1l0.8,0l1.8-0.1c0,0,0,0,0.1,0l1.7,0c0,0,0.1,0,0.1,0l1.7,0.2
              c0.1,0,0.1,0,0.2,0l0.7-0.1c0.6,0,1.1,0.4,1,1l0,0.6c0,0.5-0.5,1-1,0.9l-1.2,0l-2.1,0c0,0,0,0-0.1,0l-1.2,0.1
              c-0.5,0-0.9,0.5-0.9,1l0,0.4c0,0.5,0.4,0.9,0.9,0.9l0.9,0.1c0,0,0.1,0,0.1,0l0.8,0c0.5,0,1,0.4,1,0.9l0,0.6
              c0,0.5-0.4,0.9-0.9,1l-0.9,0.1c0,0-0.1,0-0.1,0l-0.8,0c-0.6,0-1,0.4-1,1l0,0.5c0,0,0,0.1,0,0.1l0,0.5c0,0.6,0.5,1.1,1,1
              l0.5-0.1c0,0,0.1,0,0.1,0l1.6,0.1c0,0,0.1,0,0.1,0l1.6-0.1c0,0,0.1,0,0.1,0l0.7,0.1c0.5,0,0.9,0.4,0.9,0.9l0,0.7
              c0,0.6-0.5,1-1,1l-0.8-0.1c0,0-0.1,0-0.1,0l-1.8,0.1l-1.8,0.1c0,0-0.1,0-0.1,0l-1.8-0.1c0,0-0.1,0-0.1,0L107.2,109.4z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M127,108.9l-0.4-0.9c0,0,0-0.1,0-0.1l-0.3-0.9c-0.1-0.3-0.4-0.6-0.8-0.6l-1,0l-1.6,0l-1,0
              c-0.3,0-0.6,0.2-0.7,0.5l-0.3,0.9c0,0,0,0,0,0.1l-0.3,0.9c-0.1,0.4-0.4,0.6-0.8,0.6l-1.1,0c-0.6,0-1-0.6-0.8-1.1l0.3-0.8
              l0.6-1.9c0,0,0,0,0,0l0.8-1.8l0.7-1.9l0.8-1.8l0.8-1.8c0,0,0-0.1,0-0.1l0.4-1.3c0.1-0.4,0.4-0.6,0.8-0.6l1.4,0
              c0.3,0,0.6,0.2,0.8,0.5l0.5,1.3c0,0,0,0,0,0l0.6,1.9l0.7,1.9l0.8,1.8l0.7,1.8c0,0,0,0,0,0l0.6,1.9l0.3,0.8
              c0.2,0.5-0.2,1.1-0.8,1.1l-0.2,0c0,0,0,0-0.1,0l-0.9,0C127.4,109.4,127.1,109.2,127,108.9z M124.4,101.6l-0.4-0.9
              c0-0.1,0-0.1-0.1-0.2c0,0-0.3-0.7-0.5,0.1c-0.2,0.8-0.3,1.1-0.3,1.1l-0.4,1.3c-0.2,0.5,0.2,1.1,0.8,1.1l0.3,0l0.3,0
              c0.5,0,0.9-0.5,0.8-1.1l-0.3-1.3C124.5,101.7,124.4,101.6,124.4,101.6z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M136.9,99c-0.3,0-0.6,0.3-0.6,0.6l0,1.1l-0.1,1.7c0,0,0,0,0,0.1l0.1,1.7c0,0,0,0,0,0.1l-0.1,1.7l-0.1,1.7
              c0,0,0,0,0,0l0.1,1.2c0,0.4-0.3,0.6-0.6,0.6l-1.4,0c-0.4,0-0.6-0.3-0.6-0.7l0.1-1.1c0,0,0-0.1,0-0.1l-0.1-1.7l0-1.8l0-1.8
              l0-1.8l0-1.2c0-0.3-0.3-0.6-0.6-0.6l-1.3,0c0,0,0,0-0.1,0l-1.2,0.1c-0.4,0-0.7-0.3-0.7-0.7l0.1-1.3c0-0.3,0.3-0.5,0.6-0.6
              l1.4-0.1c0,0,0.1,0,0.1,0l2,0.1l2,0.1c0,0,0,0,0.1,0l2-0.1c0,0,0,0,0.1,0l1.4,0c0.3,0,0.6,0.3,0.6,0.6l0,1.3
              c0,0.3-0.3,0.6-0.6,0.6l-1.3,0L136.9,99z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M142.7,108.8l-0.1-1.1c0,0,0,0,0,0l0-1.8c0,0,0,0,0,0l0.1-1.9l0.1-1.8c0,0,0-0.1,0-0.1l-0.1-1.8l-0.1-1.8
              c0,0,0,0,0-0.1l0-1.1c0-0.4,0.4-0.7,0.8-0.7l1.2,0c0.4,0,0.7,0.3,0.7,0.7l0.1,1.1c0,0,0,0.1,0,0.1l-0.1,1.8c0,0,0,0.1,0,0.1
              l0.1,1.8c0,0,0,0,0,0l0,1.8l-0.1,1.9l-0.1,1.8c0,0,0,0,0,0.1l0,1.1c0,0.4-0.3,0.8-0.8,0.8l-1.2-0.1
              C143.1,109.4,142.8,109.1,142.7,108.8z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M154.7,109.5l-1.6,0c-0.3,0-0.6-0.2-0.7-0.5l-0.5-1.4c0,0,0,0,0-0.1l-0.5-1.9c0,0,0,0,0,0l-0.6-1.9
              l-0.7-1.8c0,0,0,0,0-0.1l-0.8-1.7c0,0,0-0.1,0-0.1l-0.6-1.8c0,0,0,0,0-0.1l-0.2-0.9c-0.1-0.5,0.2-1,0.7-0.9l0.4,0c0,0,0,0,0,0
              l0.8,0c0.3,0,0.6,0.2,0.7,0.5l0.4,1.3c0,0,0,0.1,0,0.1l0.8,1.7c0,0,0,0.1,0,0.1l0.4,1.9c0,0,0,0,0,0l0.6,1.9l0.2,0.6l0.2,0.5
              c0,0,0,0.1,0,0.1l0.2,0.4c0,0,0,0.1,0,0.1l0.1,0.4l0.2-1l0.2-1.1c0-0.1,0-0.1,0-0.1l0.7-1.7c0,0,0-0.1,0-0.1l0.4-1.8
              c0-0.1,0-0.1,0-0.2l0.7-1.7c0,0,0-0.1,0-0.1l0.3-1.3c0.1-0.3,0.4-0.6,0.7-0.6l0.9,0c0,0,0,0,0,0l0.4,0c0.5,0,0.9,0.6,0.7,1
              l-0.4,0.8c0,0,0,0.1,0,0.1l-0.5,1.8c0,0,0,0,0,0.1l-0.6,1.8c0,0,0,0,0,0l-0.8,1.8l-0.8,1.8c0,0,0,0,0,0.1l-0.6,1.9l-0.4,1.4
              C155.3,109.3,155,109.5,154.7,109.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M162.3,108.5l0.1-0.8c0,0,0,0,0-0.1l0-1.8l0-1.9l0-1.9l0-1.9l0-1.9l0-0.9c0-0.5,0.4-1,0.9-0.9l0.8,0l1.8,0
              c0,0,0.1,0,0.1,0l1.7-0.2c0,0,0.1,0,0.1,0l1.8,0l0.9,0c0.5,0,0.9,0.4,0.9,0.9l0,0.7c0,0.5-0.4,0.9-0.9,0.9l-1.2,0l-2.1,0.1
              c0,0-0.1,0-0.1,0l-1.2-0.1c-0.5,0-1,0.4-1,0.9l0,0.4c0,0.5,0.5,1,1,0.9l0.9-0.1c0,0,0.1,0,0.1,0l1,0c0.5,0,0.9,0.4,0.9,0.9
              l0,0.8c0,0.5-0.5,1-1,0.9l-0.9-0.1c0,0-0.1,0-0.1,0l-0.9,0c-0.5,0-1,0.5-0.9,1l0.1,0.6c0,0.1,0,0.1,0,0.2l-0.1,0.6
              c0,0.5,0.4,1,0.9,1l0.7,0c0,0,0.1,0,0.1,0l1.6-0.2c0,0,0.1,0,0.1,0l1.6,0c0,0,0,0,0.1,0l0.8,0c0.5,0,0.9,0.4,0.9,0.9l0,0.9
              c0,0.5-0.4,0.9-0.9,0.9l-1,0c0,0-0.1,0-0.1,0l-1.8-0.2c0,0,0,0-0.1,0l-1.8,0l-1.8,0c0,0-0.1,0-0.1,0l-0.8,0.1
              C162.7,109.5,162.2,109,162.3,108.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M182.4,99.8l0,0.8c0,0.5,0.4,0.9,0.9,0.9l1.2,0l1.1,0c0.5,0,0.9,0.4,0.9,0.8l0,0.8c0,0.5-0.4,1-0.9,0.9
              l-1.1,0c0,0,0,0,0,0l-1.1,0c-0.5,0-0.8,0.4-0.9,0.8l-0.1,1c0,0,0,0,0,0.1l0,1.8c0,0,0,0,0,0l0.1,0.9c0,0.5-0.4,1-0.9,0.9
              l-0.9,0c-0.5,0-0.9-0.4-0.9-0.9l0-1c0,0,0-0.1,0-0.1l0.1-1.8c0,0,0-0.1,0-0.1l-0.1-1.8l0-1.9l0-1.9l0.1-1.8c0,0,0,0,0-0.1
              l0-0.9c0-0.5,0.4-0.9,0.9-0.9l0.9,0c0,0,0,0,0.1,0l1.8-0.1c0,0,0.1,0,0.1,0l1.8,0.1c0,0,0,0,0,0l1.8,0c0,0,0.1,0,0.1,0l0.9-0.1
              c0.5,0,1,0.4,1,0.9l0,0.7c0,0.5-0.4,0.8-0.9,0.8l-0.7,0c0,0,0,0,0,0l-1.7,0l-1.7,0l-0.9,0C182.8,98.9,182.4,99.3,182.4,99.8z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M200.6,108.2l-1.6,1c-0.1,0.1-0.2,0.1-0.3,0.1l-1.8,0.4c-0.1,0-0.2,0-0.3,0l-1.9-0.4
              c-0.1,0-0.2-0.1-0.3-0.1l-1.4-0.9c-0.1-0.1-0.2-0.2-0.3-0.3l-0.9-1.6c-0.1-0.1-0.1-0.2-0.1-0.4l-0.1-2.4c0,0,0,0,0,0l0-1.8
              l0-1.8c0,0,0-0.1,0-0.1l-0.2-1.7c0-0.1,0-0.1,0-0.2l0.1-1c0-0.4,0.4-0.7,0.8-0.7l1-0.1c0.5,0,0.9,0.3,0.9,0.8l0,1l0,1.8
              c0,0,0,0,0,0.1l-0.1,1.8c0,0,0,0,0,0.1l0,1.6c0,0.1,0,0.2,0.1,0.3l0.7,2c0.1,0.2,0.2,0.4,0.4,0.5l1.2,0.6
              c0.2,0.1,0.5,0.1,0.7,0l1.2-0.6c0.2-0.1,0.3-0.3,0.4-0.5l0.7-2c0-0.1,0-0.2,0.1-0.3l0-1.7c0,0,0-0.1,0-0.1l-0.1-1.8
              c0,0,0-0.1,0-0.1l0-1.8l0-1.1c0-0.5,0.4-0.9,0.8-0.9l1,0c0.5,0,0.8,0.4,0.8,0.9l0,1.1L202,100c0,0,0,0.1,0,0.1l0.1,1.8l0,1.8
              c0,0,0,0,0,0.1l-0.1,1.5c0,0,0,0,0,0.1l-0.2,1.4c0,0.1-0.1,0.3-0.1,0.4l-0.7,1C200.8,108.1,200.7,108.2,200.6,108.2z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M206.3,109.5c-0.5,0-0.9-0.4-0.8-0.9l0-1l0.1-1.8c0,0,0-0.1,0-0.1l-0.1-1.8c0,0,0,0,0-0.1l0-1.8l0.1-1.8
              c0,0,0-0.1,0-0.1l-0.1-1.8c0,0,0-0.1,0-0.1l0-0.9c0-0.5,0.4-0.9,1-0.9l0.9,0c0,0,0,0,0,0l1.8,0c0,0,0,0,0.1,0l1.7-0.1
              c0.1,0,0.1,0,0.2,0l1.7,0.2c0,0,0.1,0,0.1,0l0.8,0c0.5,0,1,0.4,1,0.9V98c0,0.5-0.4,0.9-0.9,0.9l-1.3,0l-2.2,0l-1.2,0
              c-0.5,0-0.9,0.4-0.9,1l0,0.3c0,0.5,0.4,0.9,0.9,0.9l0.9,0l1,0c0.5,0,0.9,0.4,0.9,0.9l0,0.7c0,0.5-0.4,1-1,0.9l-0.9-0.1
              c0,0,0,0-0.1,0l-0.9,0c-0.5,0-0.9,0.4-0.9,1l0,0.7l0,0.7c0,0.5,0.4,0.9,0.8,0.9l0.8,0.1c0,0,0.1,0,0.1,0l1.6,0l1.7,0l0.8,0
              c0.5,0,1,0.4,0.9,0.9l0,0.8c0,0.5-0.4,0.9-0.9,0.9l-1,0c0,0,0,0-0.1,0l-1.8,0c0,0,0,0-0.1,0l-1.8,0.1c0,0,0,0-0.1,0l-1.8,0
              c0,0,0,0-0.1,0L206.3,109.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                style={{ fill: '#F9F5E5' }}
                d="M218.4,109.4c-0.4,0-0.8-0.4-0.8-0.8l0-1l-0.1-1.8c0,0,0,0,0-0.1l0-1.8l0.1-1.8c0,0,0-0.1,0-0.1l-0.1-1.8
              l-0.1-1.9c0,0,0,0,0,0l0-1c0-0.4,0.4-0.8,0.8-0.8l0.9,0c0.4,0,0.8,0.4,0.8,0.8l0,0.9c0,0,0,0,0,0.1l0.1,1.7l0.1,1.7
              c0,0,0,0.1,0,0.1l-0.1,1.7c0,0,0,0,0,0.1l0,1.7l0,1c0,0.4,0.4,0.8,0.8,0.8l1.4,0c0,0,0,0,0.1,0l2.1-0.2c0,0,0.1,0,0.1,0
              l1.4,0.1c0.4,0,0.8,0.4,0.8,0.8l0,0.9c0,0.4-0.4,0.8-0.8,0.8l-1,0l-1.8-0.1c0,0-0.1,0-0.1,0l-1.8,0.1c0,0,0,0-0.1,0l-1.8,0
              L218.4,109.4z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#F9F5E5' }}
              d="M240.3,103.1c-2.2,1.9-1.9,2.3-4.1,4.2c-0.4,0.3-1-0.1-1-0.6c0-3.8-0.3-3.8-0.3-7.6c0-0.5,0.7-0.7,1.1-0.4
            c2.2,1.9,2.2,1.8,4.4,3.7C240.8,102.7,240.6,102.9,240.3,103.1z"
            />
          </g>
          <g>
            <path
              style={{ fill: '#F9F5E5' }}
              d="M63.9,103.1c2.2,1.9,1.9,2.2,4.1,4.1c0.4,0.3,1.3-0.1,1.3-0.6c0-3.8-0.4-3.8-0.4-7.6c0-0.5-0.4-0.8-0.8-0.5
            c-2.2,1.9-2.1,2-4.3,3.9C63.5,102.7,63.6,102.9,63.9,103.1z"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="Guilds"></g>
  </svg>
)
